import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar, Splashscreen } from 'ionic-native';
import { Service } from './service';
import { HomePage } from '../pages/home/home';
import { Settings } from '../pages/settings/settings';
import { StufenSelector } from '../pages/stufe/stufe';
import { ThemenSelector } from '../pages/thema/thema';
import { Question } from '../pages/question/question';
import { QrCode } from '../pages/qrcode/qrcode';
import { QRCodeComponent } from 'ng2-qrcode';

@Component({
  templateUrl: 'app.html',
  providers: [Service]
})
export class Wissenstest {
  rootPage = HomePage;

  //DataProvider = new Service(true);

  constructor(platform: Platform, private DataProvider: Service) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.styleDefault();
      Splashscreen.hide();
      //preload questions from file
      DataProvider.preloadQuestions();
      DataProvider.preloadSettings();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts